import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Menu, X, MapPin } from "lucide-react";

const NAV_LINKS = [
  { label: "Inicio", href: "#inicio", id: "inicio" },
  { label: "Carta", href: "#carta", id: "carta" },
  { label: "Delivery", href: "#delivery", id: "delivery" },
  { label: "Locales", href: "#locales", id: "locales" },
  { label: "Nosotros", href: "#nosotros", id: "nosotros" },
  { label: "Contacto", href: "#contacto", id: "contacto" },
  { label: "Catering", href: "/catering", id: "catering", route: true },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const base = pathname === "/" ? "" : "/";
  const linkHref = (link) => (link.route ? link.href : `${base}${link.href}`);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-brand-cream/95 backdrop-blur border-b border-brand-charcoal/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 md:h-20 flex items-center justify-between">
        <a
          href={`${base}#inicio`}
          data-testid="header-logo-link"
          className="flex flex-col items-start gap-1.5"
          aria-label="CROC LAB - Ir al inicio"
        >
          <img src="/brand/croc-logo.png" alt="CROC LAB" className="h-10 md:h-12 w-auto" />
          <span
            data-testid="header-tricolore"
            className="flex h-[3px] w-14 md:w-16 overflow-hidden rounded-full"
            aria-hidden="true"
          >
            <span className="flex-1 bg-[#008C45]" />
            <span className="flex-1 bg-white ring-1 ring-inset ring-black/10" />
            <span className="flex-1 bg-[#CD212A]" />
          </span>
        </a>
        <nav className="hidden lg:flex items-center gap-8" aria-label="Navegación principal">
          {NAV_LINKS.map((link) => (
            <a
              key={link.id}
              data-testid={`nav-link-${link.id}`}
              href={linkHref(link)}
              className="text-sm font-medium text-brand-charcoal/80 hover:text-brand-pink transition-colors"
            >
              {link.label}
            </a>
          ))}
        </nav>
        <a
          href="https://maps.app.goo.gl/3ZcPNSGucypFjynt5"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-cta-button"
          className="hidden md:inline-flex items-center gap-2 bg-brand-pink text-white text-sm font-semibold uppercase tracking-wide rounded-full px-6 py-2.5 hover:bg-brand-pink/90 hover:scale-105 transition-transform"
        >
          <MapPin className="w-4 h-4" aria-hidden="true" />
          Encuentra tu Croc
        </a>
        <button
          data-testid="nav-hamburger-button"
          className="lg:hidden p-2 text-brand-charcoal"
          aria-label={open ? "Cerrar menú" : "Abrir menú"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <nav
          data-testid="mobile-menu-panel"
          className="lg:hidden border-t border-brand-charcoal/10 bg-brand-cream px-6 py-4 flex flex-col gap-1"
          aria-label="Navegación móvil"
        >
          {NAV_LINKS.map((link) => (
            <a
              key={link.id}
              data-testid={`mobile-nav-link-${link.id}`}
              href={linkHref(link)}
              onClick={() => setOpen(false)}
              className="py-3 text-base font-medium text-brand-charcoal hover:text-brand-pink transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://maps.app.goo.gl/3ZcPNSGucypFjynt5"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-nav-cta-button"
            onClick={() => setOpen(false)}
            className="mt-2 inline-flex items-center justify-center gap-2 bg-brand-pink text-white font-semibold rounded-full px-6 py-3"
          >
            <MapPin className="w-4 h-4" aria-hidden="true" />
            Encuentra tu Croc
          </a>
        </nav>
      )}
    </header>
  );
};

export default Header;
